var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-350.000000, -412.000000)",
    id: "User_Circle",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.5,447 C357.854,447 350,439.146 350,429.5 C350,419.854 357.854,412 367.5,412 C377.146,412 385,419.854 385,429.5 C385,439.146 377.146,447 367.5,447 Z M356.65,441.386 C359.52,444.004 363.328,445.6 367.5,445.6 C371.672,445.6 375.48,444.004 378.35,441.386 C377.384,439.174 374.556,437.998 372.274,437.06 C369.908,436.094 369.6,434.82 369.6,433.714 C369.6,432.636 370.118,431.446 370.902,430.746 C371.952,429.822 372.498,428.548 372.498,427.05 C372.498,424.53 370.93,421.814 367.5,421.814 C364.14,421.814 362.628,424.446 362.628,427.05 C362.628,428.618 363.132,429.864 364.14,430.746 C365.064,431.572 365.4,432.86 365.4,433.714 C365.4,434.834 365.092,436.094 362.824,437.018 C360.444,437.998 357.616,439.174 356.65,441.386 Z M367.5,420.4 C371.21,420.4 373.898,423.186 373.898,427.036 C373.898,428.94 373.184,430.592 371.826,431.782 C371.35,432.216 371,433.014 371,433.7 C371,434.316 371,435.016 372.694,435.716 C375.046,436.696 378.042,437.942 379.386,440.35 C382.004,437.494 383.6,433.686 383.6,429.514 C383.6,420.638 376.376,413.414 367.5,413.414 C358.624,413.414 351.4,420.638 351.4,429.514 C351.4,433.686 352.996,437.494 355.614,440.35 C356.958,437.942 359.954,436.696 362.194,435.772 C364.014,435.03 364.014,434.302 364.014,433.714 C364.014,433.126 363.762,432.272 363.23,431.796 C361.942,430.648 361.256,429.01 361.256,427.05 C361.228,423.13 363.818,420.4 367.5,420.4 Z",
    fill: "#0087ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/User_Circle.46808bbacfd21ec5ddda390fb79e21d6.svg";
export { ForwardRef as ReactComponent };